import { useEffect, useState } from "react";
import GeneralService from "../service/general-service";
import {
  REVIEWS,
  MIN_REAL_REVIEWS,
  toReviewCardProduct,
} from "../constant/review-content";

//—— 公開評價 ——
//
//  首頁與 /reviews 共用。回的形狀跟 constant/review-content 的 REVIEWS
//  一模一樣（ReviewCard 吃的那個形狀），所以兩頁都不必判「現在是真的還是備援」。
//
//  —— 為什麼要有備援 ——
//  評價是行銷素材。真實評價還沒累積起來的時候，首頁那一區如果是空的
//  或只有兩張卡，傷害比放備援大 —— 那一區的標題寫的是「最多人在看」。
//
//  —— 為什麼是「全換」而不是「補滿」 ——
//  混著放的話同一頁會同時出現寫死的「9 小時前」跟真實時間，
//  而且備援那幾則的 repeatCount 全是 0，一眼就看得出兩批資料不同源。
//  門檻與理由寫在 MIN_REAL_REVIEWS 旁邊。
//
//  —— 為什麼不卡 loading ——
//  一開始就回備援，拿到足量真實評價才換掉。首頁不該為了評價區
//  先空一塊再跳進來 —— 那一區在首頁的下半部，使用者捲到的時候早就換好了。
//  代價是「真實評價剛好是 8 則」時畫面會閃一次，可以接受。
export const useReviews = () => {
  const [real, setReal] = useState(null); //null = 還沒回來

  useEffect(() => {
    let alive = true;
    GeneralService.reviews(30)
      .then((res) => {
        if (!alive) return;
        setReal(res.data?.data?.reviews || []);
      })
      .catch(() => {
        //  取不到就繼續用備援。不要把錯誤往上丟 ——
        //  評價區掛掉不該讓整個首頁變成錯誤畫面。
        if (alive) setReal([]);
      });
    //StrictMode 下 effect 會跑兩次（掛載 → cleanup → 再掛載）。
    //  旗標要在 effect 裡設，不能用 useRef(true) 當初始值 ——
    //  第二次掛載不會重新執行 useRef 的初始值，會永遠是 false。
    return () => {
      alive = false;
    };
  }, []);

  const enough = real !== null && real.length >= MIN_REAL_REVIEWS;

  return {
    //  備援那份已經是 ReviewCard 的形狀了，真實那份要把後端的 productID
    //  查成產品摘要 —— 代號兩邊不一樣，中間那張對照表在 constant/products
    reviews: enough
      ? real.map((r) => ({ ...r, product: toReviewCardProduct(r.productID) }))
      : REVIEWS,
    //  給後台或除錯用：現在這一頁秀的是真的還是備援
    isReal: enough,
  };
};

export default useReviews;
